const components = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 0,
      },
    },
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        backgroundColor: '#f8f8f8',
        borderBottom: `1px solid #e0e0e0`,
        alignItems: 'center',
      },
      content: {
        minHeight: '56px',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '3px',
        margin: 0,
        '&.Mui-expanded': {
          margin: 0,
        },
      },
    },
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        backgroundColor: '#fff',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        boxShadow: 'none',
        border: `1px solid #efefef`,
        borderRadius: 0,
      },
    },
  },
  MuiToolbar: {
    styleOverrides: {
      root: {
        padding: 0,
        '@media (min-width: 600px)': {
          padding: 0,
        },
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        padding: '24px 16px',
      },
    },
  },
  MuiFormControlLabel: {
    styleOverrides: {
      root: {},
      label: {
        width: '100%',
      },
    },
  },
};

export default components;
